import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  createAccount,
  getStates,
  getCitiesByState,
  getBrandsForFilter,
  getAdminsAccounts,
} from 'actions/index';
import { Colors } from 'modules/theme';
import { push } from 'modules/history';
import Icon from 'components/Icon';
import H2 from 'components/H2';
import Stepper from 'components/Stepper';
import PropTypes from 'prop-types';
import DetailsForm from './DetailsForm';
import LocationsForm from './LocationsForm';

const Container = styled.div`
  box-sizing: border-box;
  max-width: 100%;
  margin: 20px;
  overflow-x: hidden;
  padding-bottom: 24px;
  @media (max-width: 767px) {
    margin: 20px auto;
    padding-left: 16px;
    padding-right: 16px;
  }
  @media (min-width: 768px) {
    margin: 30px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

const Column = styled.div`
  flex-direction: column;
  align-self: center;
  margin-right: 10px;
  margin-bottom: 10px;
  @media (max-width: 767px) {
    margin-right: 0;
  }
`;

class CreateAccount extends Component {
  state = {
    activeTab: 'Details',
    account: {},
  };

  componentDidMount() {
    const { fetchStates, fetchBrandsForFilter } = this.props;

    fetchStates();
    fetchBrandsForFilter();
  }

  getCities = stateId => {
    const { fetchCitiesByState } = this.props;

    fetchCitiesByState(stateId);
  };

  getAdminsBrandsAccounts = brandId => {
    const { fetchAdminsAccounts } = this.props;
    fetchAdminsAccounts(brandId);
  };

  saveData = (data, nextTab) => {
    const { account, activeTab } = this.state;
    const accountUpdated = {
      ...account,
      ...data,
    };

    if (activeTab === 'Locations') {
      const { submitAccount } = this.props;
      submitAccount(accountUpdated);
    } else {
      this.setState({
        activeTab: nextTab,
        account: accountUpdated,
      });
    }
  };

  switchTab = activeTab => {
    this.setState({ activeTab });
  };

  back = backTab => {
    this.setState({
      activeTab: backTab,
    });
  };

  render() {
    const { states, cities, token, brands, adminsAccounts } = this.props;
    const {
      activeTab,
      account: { locations },
    } = this.state;
    const detailsInitialValues = {
      name: '',
      address_line: '',
      address_line_1: '',
      city_id: '',
      state_id: '',
      zip_code: '',
      phone_number: '',
      contact_first_name: '',
      contact_last_name: '',
      contact_phone_number: '',
      contact_email: '',
      brand_id: '',
      createNewUser: true,
      isPointOfContact: true,
      account_admin_id: null,
    };

    const steps = [{ title: 'Details' }, { title: 'Locations' }];

    const additionalOptions =
      adminsAccounts.length > 0
        ? adminsAccounts.map(admin => ({
            label: `${admin.first_name} ${admin.last_name}`,
            value: admin.id,
          }))
        : [];

    return (
      <Container>
        <Row>
          <Column>
            <Icon onClick={() => push('/accounts')} name="chevron-left" color={Colors.blue} />
          </Column>
          <Column>
            <H2 color={Colors.black} style={{ paddingRight: 30 }}>
              Add new account
            </H2>
          </Column>
        </Row>
        <Stepper
          steps={steps}
          activeStep={activeTab}
          onStepClick={idx => this.switchTab(steps[idx].title)}
        />

        {activeTab === 'Details' && (
          <DetailsForm
            initialValues={detailsInitialValues}
            additionalOptions={additionalOptions}
            isInitialValid={false}
            cities={cities}
            states={states}
            brands={brands}
            getCities={this.getCities}
            onSubmit={this.saveData}
            getAdminsBrandsAccounts={this.getAdminsBrandsAccounts}
          />
        )}
        {activeTab === 'Locations' && (
          <LocationsForm
            token={token}
            locations={locations}
            back={() => this.back('Details')}
            onSubmit={this.saveData}
          />
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    states: state.utils.states,
    cities: state.utils.cities,
    token: state.auth.token,
    brands: state.brands.listForFilter,
    adminsAccounts: state.brands.adminsAccounts,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    submitAccount: data => dispatch(createAccount(data)),
    fetchStates: () => dispatch(getStates()),
    fetchCitiesByState: stateId => dispatch(getCitiesByState(stateId)),
    fetchBrandsForFilter: () => dispatch(getBrandsForFilter()),
    fetchAdminsAccounts: brandId => dispatch(getAdminsAccounts(brandId)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount);
CreateAccount.propTypes = {
  adminsAccounts: PropTypes.array,
  brands: PropTypes.array,
  cities: PropTypes.array,
  fetchAdminsAccounts: PropTypes.func,
  fetchBrandsForFilter: PropTypes.func,
  fetchCitiesByState: PropTypes.func,
  fetchStates: PropTypes.func,
  states: PropTypes.array,
  submitAccount: PropTypes.func,
  token: PropTypes.string,
};
